import {
    postRequestFromRecruit,
} from '../helpers/request';

export const sendFeedbackMessage = (params) => {
    const apiUrl = `teamswebhooks/feedback`;

    return postRequestFromRecruit(apiUrl, params);
};